import { render, staticRenderFns } from "./ReportTemplatePreviewTableHeader.vue?vue&type=template&id=97b4f1de&scoped=true&"
import script from "./ReportTemplatePreviewTableHeader.vue?vue&type=script&lang=js&"
export * from "./ReportTemplatePreviewTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReportTemplatePreviewTableHeader.vue?vue&type=style&index=0&id=97b4f1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b4f1de",
  null
  
)

export default component.exports